/* eslint-disable no-undef */
export const ROOT = process.env.NODE_ENV === 'production' ? 'https://cc.krgsc.kz' : ''; //"https://cc.krgsc.kz";

export const API_URI = '';
export const API_ROOT = `${ROOT}${API_URI}`;
